import { useParams } from 'react-router';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import { fetchTerminHistoriaZmienPage } from '../../../../../client/termin/terminHistoriaZmienClient';
import TerminHistoriaZmienPage from '../../../../../model/TerminHistoriaZmienPage';

interface ReturnType {
  terminHistoriaZmienPageInfo: TerminHistoriaZmienPage;
  terminHistoriaZmienPageInfoStatus: ClientStatus;
}

const useTerminHistoriaZmienPageInfo = (): ReturnType => {
  const { terminUuid } = useParams<{ terminUuid: string }>();
  const {
    data: terminHistoriaZmienPageInfo,
    status: terminHistoriaZmienPageInfoStatus,
  } = useClientFetch(
    fetchTerminHistoriaZmienPage,
    [terminUuid, undefined, undefined, undefined, undefined],
    [],
  );

  return {
    terminHistoriaZmienPageInfo,
    terminHistoriaZmienPageInfoStatus,
  };
};

export default useTerminHistoriaZmienPageInfo;
